var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-print"},[_c('SignPrintItem',{attrs:{"type":"0","info":_vm.signInfo,"date":_vm.date}}),_c('SignPrintItem',{attrs:{"type":"1","info":_vm.signInfo,"date":_vm.date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }